import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplayValidationErrorsComponent } from './components/display-validation-errors/display-validation-errors.component';

@NgModule({
  declarations: [
    DisplayValidationErrorsComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DisplayValidationErrorsComponent
  ]
})
export class DisplayValidationErrorsModule {
}
